export const BatteryNotReportingTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                    list</span>, and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Devices tab</span>.
            </li>
            <li>
                <span className="font-semibold">Wait</span> 15 minutes for potential self-diagnosis and recovery.
            </li>
            <li>
                <span className="font-semibold">Check</span> the Battery's State of Charge; allow 24 hours if
                recently depleted.
            </li>
            <li>
                <span className="font-semibold">Reset</span> the Zigbee communication kit if necessary.
            </li>
            <li>
                <span className="font-semibold">Contact Enphase Support</span> for unresolved issues.
            </li>
        </ul>
    </div>
